import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const importacaoSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    empresa: Yup.object().nullable().required(v.requiredField('empresa', 'select')),
    descricao: Yup.string()
      .min(3, 'Mínimo de 3 caracteres')
      .max(50, 'Máximo de 50 caracteres')
      .required('O campo descrição é obrigatório'),
    firstRowContainsColNames: Yup.boolean().required('O campo é obrigatório'),
    file: Yup.mixed()
      .required('O arquivo é obrigatório.')
      .test('fileType', 'Somente arquivos Excel (.xls ou .xlsx) são permitidos', (file) => {
        if (!file) return false
        const validTypes = [
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ]
        const validExtensions = ['.xls', '.xlsx']
        return (
          validTypes.includes(file.type) ||
          validExtensions.some((ext) => file.name?.toLowerCase().endsWith(ext))
        )
      }),
  })
}
